import React, { forwardRef, useCallback, useMemo, useState } from 'react'
import { FieldTypes } from 'utils/formUtils';
import TenableInfraMappingForm from './TenableInfraMappingForm';
import GenericPullCredentialsForm from '../GenericPullCredentialsForm';
import { useFeatureFlag } from 'contexts/FeatureFlagContext';
import _ from "lodash";

function TenableInfraCredentialsForm(props, ref) {
    const featureFlags = useFeatureFlag();
    const [checked, setChecked] = useState(props.config?.fetchAssets === "true" ? true : false);
    const fields = useMemo(() => [{
        name: "accessKey",
        label: "Access Key",
        required: true
    }, {
        name: "secretKey",
        label: "Secret Key",
        type: FieldTypes.PASSWORD,
        required: true
    }, ...(featureFlags.RBVM_ASSETS ? [{
        name: "fetchAssets",
        label: "Fetch Assets",
        type: FieldTypes.BOOLEAN,
        inline: true,
        props: {
            onChange: (e) => setChecked(e.target.checked),
        }
    }, ...(checked ? [{
        name: "tagFilter",
        label: "Tag Filter",
        help: "Fetches all assets with the specified tag. Specify key-value pair separated by colon. e.g. source:aws",
        rules: [{
            validator: (rule, val) => {
                if (val) {
                    const strArray = val.split(":");
                    if (
                      val.indexOf(":") === -1 ||
                      strArray.length !== 2 ||
                      _.isEmpty(strArray[0].trim()) ||
                      _.isEmpty(strArray[1].trim()) ||
                      val.includes(",")
                    ) {
                      return Promise.reject(
                        "Tag format is invalid and only single tag is allowed"
                      );
                    }
                }
                return Promise.resolve();
            }
        }]
    }] : [])] 
    :
    [])], [checked, featureFlags.RBVM_ASSETS]);

    const parseExtraFields = useCallback((config) => {
        if(config?.fetchAssets){
            return {
                ...config,
                fetchAssets: config.fetchAssets === "true" ? true : false
            }
        }
        return config;
    }, [])

    return (
        <GenericPullCredentialsForm
            {...props}
            ref={ref}
            fields={fields}
            parseExtraFields={parseExtraFields}
            MappingForm={TenableInfraMappingForm}
        />
    )
}

export default forwardRef(TenableInfraCredentialsForm);